import React, { useState, useEffect } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Typography,
    CircularProgress, Alert, List, ListItem, ListItemText, Divider, Button, Box, Link
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { getScheduledJobHistory } from '../../Utils/functions';

const JobHistoryModal = ({ job, onClose }) => {
    const [history, setHistory] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchJobHistory = async () => {
            if (!job) return;
            setLoading(true);
            setError(null);
            try {
                const data = await getScheduledJobHistory(job.id);
                setHistory(Array.isArray(data) ? data : []);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchJobHistory();
    }, [job]);

    return (
        <Dialog open={true} onClose={onClose} fullWidth maxWidth="md">
            <DialogTitle>
                <Typography variant="h6">Run History</Typography>
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <Typography gutterBottom>
                    <strong>For:</strong> {job.question}
                </Typography>
                {loading && (
                    <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
                        <CircularProgress />
                    </Box>
                )}
                {error && <Alert severity="error" sx={{ my: 2 }}>{error}</Alert>}
                {!loading && !error && (
                    history.length > 0 ? (
                        <List>
                            {history.map((run, index) => (
                                <React.Fragment key={run.id}>
                                    <ListItem alignItems="flex-start">
                                        <ListItemText
                                            primary={`Run Date: ${new Date(run.createdAt).toLocaleString()}`}
                                            secondary={
                                                <React.Fragment>
                                                    <Typography component="span" variant="body2" color="text.primary">
                                                        Status: {run.status}
                                                    </Typography>
                                                    {run.status === 'Completed' && (
                                                        <Link href={`/search/${run.id}`} target="_blank" rel="noopener noreferrer" sx={{ ml: 2 }}>
                                                            View Report
                                                        </Link>
                                                    )}
                                                    {run.status === 'Error' && (
                                                        <Typography component="p" variant="body2" color="error">
                                                            Error: {run.error}
                                                        </Typography>
                                                    )}
                                                </React.Fragment>
                                            }
                                        />
                                    </ListItem>
                                    {index < history.length - 1 && <Divider variant="inset" component="li" />}
                                </React.Fragment>
                            ))}
                        </List>
                    ) : (
                        <Typography sx={{ my: 2 }}>No run history found for this scheduled search.</Typography>
                    )
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Close</Button>
            </DialogActions>
        </Dialog>
    );
};

export default JobHistoryModal;